import React, { useState } from 'react'

const Patnanearme = (props) => {
    return (
        <>
            <div id='footerdetail' >
                <div id='callus'>
                    <div className="container">
                        <div className="row">
                            {/*<!-- End Col --> */}
                            <div className="col-md-12 col-lg-12">

                                <div className="popular-city" style={{ display: 'flex' }}>
                                    <div className="footer-widget footer-left-widgetcties-pop popular-city-footers">
                                        <div className="section-heading">
                                            <h3>RO SERVICE IN PATNA</h3>
                                            <span className="animate-border border-black"></span>
                                        </div>
                                        <ul>
                                            <li> <a href="/ro-service-Boring-Road">Boring-Road </a></li>
                                            <li> <a href="/ro-service-Kankarbagh">Kankarbagh </a></li>
                                            <li> <a href="/ro-service-Rajendra-Nagar">Rajendra-Nagar </a></li>
                                            <li> <a href="/ro-service-Patliputra-Colony">Patliputra-Colony </a></li>
                                            <li> <a href="/ro-service-Bailey-Road">Bailey-Road </a></li>
                                            <li> <a href="/ro-service-Ashiana-Nagar">Ashiana-Nagar </a></li>
                                            <li> <a href="/ro-service-Fraser-Road">Fraser-Road </a></li>
                                            <li> <a href="/ro-service-Anishabad">Anishabad </a></li>
                                            <li> <a href="/ro-service-Phulwari-Sharif">Phulwari-Sharif </a></li>
                                            <li> <a href="/ro-service-Danapur">Danapur </a></li>
                                            <li> <a href="/ro-service-Kurji">Kurji </a></li>
                                            <li> <a href="/ro-service-Gandhi-Maidan">Gandhi-Maidan </a></li>
                                            <li> <a href="/ro-service-Agamkuan">Agamkuan </a></li>
                                            <li> <a href="/ro-service-Kadamkuan">Kadamkuan </a></li>
                                            <li> <a href="/ro-service-Exhibition-Road">Exhibition-Road </a></li>
                                            <li> <a href="/ro-service-SagunaMor">SagunaMor </a></li>
                                            <li> <a href="/ro-service-GolaRoad">GolaRoad </a></li>
                                            <li> <a href="/ro-service-Athmalgola">Athmalgola </a></li>
                                            <li> <a href="/ro-service-Bankipore">Bankipore </a></li>
                                            <li> <a href="/ro-service-Salimpur">Salimpur </a></li>
                                            <li> <a href="/ro-service-Sheikhpura-Patna">Sheikhpura-Patna </a></li>
                                            <li> <a href="/ro-service-Sherpur">Sherpur </a></li>
                                            <li> <a href="/ro-service-Sultanpur">Sultanpur </a></li>
                                            <li> <a href="/ro-service-Vidyut-Parisad">Vidyut-Parisad </a></li>
                                            <li> <a href="/ro-service-Hajipur">Hajipur </a></li>
                                            <li> <a href="/ro-service-Patna City">Patna City </a></li>
                                            <li> <a href="/ro-service-Kumhrar">Kumhrar </a></li>
                                            <li> <a href="/ro-service-musallahpurhat">musallahpurhat </a></li>
                                            <li> <a href="/ro-service-gulzarbagh">gulzarbagh </a></li>
                                            <li> <a href="/ro-service-AshokRajpath">AshokRajpath </a></li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default Patnanearme;